import React from 'react';
import { Link } from 'react-router-dom';

function CategorySliderItem(props) {
  const { category, path } = props;
  const link = path === null ? `${category.id}/${category.uniq_title}` : `${path}/${category.id}/${category.uniq_title}`;

  return (
    <Link to={link} className="item rtl">
      <div className="align-content-stretch align-items-center justify-content-center f-00auto">
        <div className="c1 d-flex align-items-center" aria-disabled="false">
          <div className="c2 d-block align-self-center f-none u-select-none c-p">
            <div className="cat-image bg-main br-50 o-hidden p-relative">
              <img className="wh-100" alt={category.title} src={category.image} />
            </div>
          </div>
          <div className="cat-title d-block w-100 c-p o-hidden text-center to-ellipsis w-space-nowrap">
            {category.title}
          </div>
        </div>
      </div>
    </Link>
  );
}

export default CategorySliderItem;
